import {
  Driver
} from "./data-management";

export class RealTimeRecord {
  idRealTimeRecord: number;
  recordTime: Date;
  coordinate: {
    lat: number,
    lng: number
  };
  odo:number;
  accum_odo: number;
  speed: number;
  temperature: string;
  validity: boolean;
  ignition: boolean;
  power: number;
  mems_x: number;
  mems_y: number;
  mems_z: number;
  sendFlag: number;
  type: 'AA' | 'GPRMC';
  satInView: number;
  signal: string;
  heading: number;
  matricule: string;
  mark: string;
  realTimeRecordStatus: string;
  geocoding: string;
  geocodingDetails: string;
  relativePosition: string;
  rotationAngle: number;
  icon: string;
  vehicule: Vehicule = null;

  constructor() {
    this.geocoding = `Chargement..`;
    this.geocodingDetails = 'Chargement..';
    this.speed = 0;
    this.recordTime = new Date();
    this.coordinate = {
      lat: 0,
      lng: 0
    };
    this.realTimeRecordStatus = '';
    this.rotationAngle = 0;
  }

}

export class Group {
  nom: string;
  isOpen: boolean;
  vehicules: Vehicule[];
  icon: string;
}
export class CalTravel{
  deviceId: number;
  accumOdo: number;
  lastTime: Date;
}
export class Vehicule {
  idDevice: number;
  matricule: string;
  mark: string;
  recordTime: Date;
  coordinate: {
    lat: number,
    lng: number
  };
  odo: number;
  odoOffset: number;
  geocoding: string;
  geocodingDetails: string;
  speed: number;
  driverName: string;
  driver: Driver;
  idGroup:number;
  realTimeRecord: RealTimeRecord;

  constructor() {
    this.realTimeRecord = new RealTimeRecord();
  }
}
export class User {

  id: number;
  displayName: string;
  username: string;
  email: string;
  enabled: boolean;
  token: string;
  isRoot: boolean;
  password: string;
  server: string;
  authorities: Authority[];
  groups: Group[];

  constructor() {
    this.username = '';
    this.email = '';
    this.server = '';
    this.authorities = [];
    this.groups = [];
    this.enabled = true;
    this.isRoot = false;
  }
}

export class Authority {
  id: string;
  name: 'ROLE_ROOT' | 'ROLE_RT' | 'ROLE_PATH' | 'ROLE_PATH' | 'ROLE_DM' | 'ROLE_PM' | 'ROLE_AM' | 'ROLE_RM' | 'ROLE_OV' | 'ROLE_ED';
  label: string;

  constructor() {}
}

export class Credentials {
  username: string;
  password: string;

  constructor() {
    this.username = '';
    this.password = '';
  }
}
export class Stop {

  stopDurationStr: string;
  deviceId: number;
  beginStopTime: number;
  stopDuration: Date;
  stopLatitude: number;
  stopLongitude: number;
  endStopTime: Date
  inPath: boolean
  geocoding: string;
  geocodingDetails: string;

  constructor() {}

}
export class Mileage {
  deviceId : number;
  startHour: Date;
  endHour: Date;
  drivingDistance: number;
  drivingDurationStr: string;

  constructor() {
    this.drivingDistance = 0;
    this.drivingDurationStr = '';
  }

}

export class Path {

    nextStopDuration: number;
    nextStopDurationStr: string;
    pathDurationStr: string;

    beginPathLatitude: number;
    beginPathLongitude: number;

    endPathLatitude: number;
    endPathLongitude: number;

    beginPathGeocoding: string;
    endPathGeocoding: string;

    beginPathGeocodingDetails: string;
    endPathGeocodingDetails: string;

    beginPathTime: Date;
    endPathTime: Date;

    displayBeginPathTime: Date;
    displayEndPathTime: Date;

    deviceId: number;

    pathDuration: number;
    maxSpeed: number;

    distanceDriven: number;

    constructor() {

    }

}



// WEBPACK FOOTER //
// ./src/objects/real-time.ts